import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PubNubProvider } from "pubnub-react";
import PubNub from "pubnub";
import Layout from "./layout/Layout";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Vendors from "./pages/Vendors/Vendors";
import AddVendor from "./pages/Vendors/AddVendor";
import VendorViewProfile from "./pages/Vendors/ViewProfile";
import Users from "./pages/Users/Users";
import UserViewProfile from "./pages/Users/ViewProfile";
import Doctors from "./pages/Doctors/Doctors";
import AddDoctor from "./pages/Doctors/AddDoctor";
import CreateAvailability from "./pages/Doctors/CreateAvailability";
import DoctorAvailability from "./pages/Doctors/DoctorAvailability";
import UserDoctorAvailability from "./pages/Users/DoctorAvailability";
import ViewProfile from "./pages/Doctors/ViewProfile";
import DoctorProfile from "./pages/Doctors/DoctorProfile";
import Support from "./pages/Support/Support";
import AddUser from "./pages/Users/AddUser";
import Revenue from "./pages/Revenue/Revenue";
import ForgotPassword from "./pages/auth/ForgotPassword";
import NotFound from "./pages/NotFound";
import AccessDenied from "./pages/AccessDenied";
import ProtectedRoute from "./components/ProtectedRoute";
import ChatApp from "./pages/chat/ChatApp";
import * as apicall from "./components/Apicall";
import {
  pub_nub_publishKey,
  pub_nub_subscribeKey,
  pub_nub_uuid,
  pub_nub_publishKey_admin,
  pub_nub_subscribeKey_admin,
  pub_nub_uuid_admin,
  admin_role_id,
} from "./constants/Constants";
import Reports from "./pages/Reports/Reports";

import { PrimeReactProvider } from "primereact/api";
import Bookings from "./pages/Vendor_bookings/Bookings";
import AddItems from "./pages/Vendor_bookings/AddItems";
import AddOfferings from "./pages/Vendor_bookings/AdminSetup";
import NewDashboard from "./pages/Dashboard/NewDashboard";
import Providers from "./pages/Providers/Providers";
import AddProvider from "./pages/Providers/AddProvider";
import ProviderAvailability from "./pages/Providers/ProviderAvailability";
import ProviderProfile from "./pages/Providers/ProviderProfile";
import NewDashboard1 from "./pages/Dashboard/NewDashboard1";
import DashboardDetailed from "./pages/Dashboard/DashboardDetailed";
import ProfileSetup from "./pages/auth/ProfileSetup";
import Setup from "./pages/Dashboard/Setup";
import PricingPage from "./pages/Pricing/Pricing";
import CustomerBooking from "./pages/Vendor_bookings/CustomerBooking";

// Initialize PubNub for vendor chat
const vendorPubnub = new PubNub({
  publishKey: pub_nub_publishKey,
  subscribeKey: pub_nub_subscribeKey,
  uuid: pub_nub_uuid,
});

// Initialize PubNub for admin chat
const adminPubnub = new PubNub({
  publishKey: pub_nub_publishKey_admin,
  subscribeKey: pub_nub_subscribeKey_admin,
  uuid: pub_nub_uuid_admin,
});

function App() {
  const { pathname } = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [notifications, setNotifications] = useState({});
  const [currentChannel, setCurrentChannel] = useState(null);
  const [isPortrait, setIsPortrait] = useState(false);

  let allServices = JSON.parse(localStorage.getItem("services"));
  const isClinicService = allServices?.some(
    (ele) => ele?.service_name === "Clinical Appointment"
  );

  // useEffect(() => {
  //   const checkOrientation = () => {
  //     // Method 1: Use Screen Orientation API if available
  //     if (window.screen?.orientation?.type) {
  //       const orientation = window.screen.orientation.type;
  //       setIsPortrait(orientation.includes("portrait"));
  //     }
  //     // Method 2: Fallback to dimensions check
  //     else {
  //       setIsPortrait(window.innerHeight > window.innerWidth);
  //     }
  //   };

  //   // Initial check
  //   checkOrientation();

  //   // Add all possible event listeners
  //   window.addEventListener("resize", checkOrientation);
  //   window.addEventListener("orientationchange", checkOrientation);
  //   if (window.screen?.orientation) {
  //     window.screen.orientation.addEventListener("change", checkOrientation);
  //   }

  //   // Cleanup
  //   return () => {
  //     window.removeEventListener("resize", checkOrientation);
  //     window.removeEventListener("orientationchange", checkOrientation);
  //     if (window.screen?.orientation) {
  //       window.screen.orientation.removeEventListener(
  //         "change",
  //         checkOrientation
  //       );
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   if (isPortrait) {
  //     alert("Please rotate to landscape for best experience");
  //     // Or show a custom UI message instead of alert
  //   }
  // }, [isPortrait]);

  useEffect(() => {
    if (isLoggedIn && userRole === admin_role_id.toString()) {
      const fetchChannels = async () => {
        try {
          const res = await apicall.get("admin_chatInfo");
          const channels = res.data.map((user) => user.pubnub_channel_id);
          adminPubnub.subscribe({ channels });

          adminPubnub.addListener({
            message: (event) => handleNewMessage(event),
          });

          const hasUnread = Object.values(notifications).some(
            (count) => count > 0
          );
          setHasUnreadMessages(hasUnread);
        } catch (error) {
          console.error("Error fetching channels:", error);
        }
      };

      fetchChannels();

      return () => {
        adminPubnub.unsubscribeAll();
      };
    }
  }, [isLoggedIn, userRole]);

  const handleNewMessage = (event) => {
    const { channel, publisher } = event;

    if (publisher === adminPubnub.getUUID()) {
      return;
    }

    if (!pathname.startsWith("/chat")) {
      toast.info("New message received");
    }

    setNotifications((prevNotifications) => {
      const updatedNotifications = {
        ...prevNotifications,
        [channel]: (prevNotifications[channel] || 0) + 1,
      };

      setHasUnreadMessages(true);
      return updatedNotifications;
    });
  };

  const resetNotifications = (channel = null) => {
    setNotifications((prevNotifications) => {
      if (channel) {
        const { [channel]: _, ...remainingNotifications } = prevNotifications;
        setHasUnreadMessages(
          Object.values(remainingNotifications).some((count) => count > 0)
        );
        return remainingNotifications;
      } else {
        setHasUnreadMessages(false);
        return {};
      }
    });
  };

  useEffect(() => {
    if (pathname.startsWith("/chat") && currentChannel) {
      resetNotifications(currentChannel);
    }
  }, [pathname, currentChannel]);

  // Determine which PubNub instance to use based on user role
  const getPubNubInstance = () => {
    return userRole === admin_role_id.toString() ? adminPubnub : vendorPubnub;
  };

  return (
    <PrimeReactProvider>
      <PubNubProvider client={getPubNubInstance()}>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/book-service/vendor/:id"
            element={<CustomerBooking />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/profile-setup" element={<ProfileSetup />} />

          {/* Vendor Routes */}
          <Route element={<ProtectedRoute allowedRoles={["3"]} />}>
            <Route element={<Layout />}>
              <Route
                path="/dashboard"
                element={isClinicService ? <Dashboard /> : <NewDashboard1 />}
              />
              <Route path="/setup" element={<Setup />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/dashboard/:date" element={<DashboardDetailed />} />
              <Route path="/new_dashboard" element={<NewDashboard />} />
              <Route path="/dashboard/view-profile" element={<ViewProfile />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/doctors/profile/:id" element={<DoctorProfile />} />
              <Route path="/doctors/add" element={<AddDoctor />} />
              <Route path="/providers" element={<Providers />} />

              <Route
                path="/providers/profile/:id"
                element={<ProviderProfile />}
              />
              <Route path="/providers/add" element={<AddProvider />} />
              <Route
                path="/doctors/add/availability"
                element={<DoctorAvailability />}
              />
              <Route
                path="/providers/add/availability"
                element={<ProviderAvailability />}
              />
              <Route
                path="/doctors/create-availability"
                element={<CreateAvailability />}
              />
              <Route path="/supports" element={<Support />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/vendor_bookings" element={<Bookings />} />
              <Route path="/vendor_bookings/:group_id" element={<Bookings />} />
              <Route path="/add_items" element={<AddItems />} />
              <Route path="/add_offerings" element={<AddOfferings />} />
              <Route
                path="/vendors/view-profile"
                element={<VendorViewProfile />}
              />
            </Route>
          </Route>

          {/* Admin Routes */}
          <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
            <Route element={<Layout />}>
              <Route path="/users" element={<Users />} />
              <Route
                path="/users/view-profile/:id"
                element={<UserViewProfile />}
              />
              <Route
                path="/users/add/availability"
                element={<UserDoctorAvailability />}
              />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/vendors/add" element={<AddVendor />} />
              <Route path="/users/profile/:id" element={<DoctorProfile />} />
              <Route
                path="/vendors/view-profile"
                element={<VendorViewProfile />}
              />
              <Route path="/vendors/view-profile/:id" element={<Dashboard />} />
              <Route path="/vendors/edit/:id" element={<AddVendor />} />
              <Route path="/users/add" element={<AddUser />} />
              <Route path="/revenue" element={<Revenue />} />
              <Route
                path="/chat"
                element={
                  <ChatApp
                    resetNotifications={resetNotifications}
                    setCurrentChannel={setCurrentChannel}
                  />
                }
              />
            </Route>
          </Route>

          {/* 404 Route */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </PubNubProvider>
    </PrimeReactProvider>
  );
}

export default App;
